// Contact details used across the site. WhatsApp is the main channel.
const WHATSAPP_NUMBER = "18768187799";
const WHATSAPP_GREETING = "Hi Adrian, I'd like to talk about a project.";

export default {
  whatsappUrl: `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    WHATSAPP_GREETING
  )}`,
  email: "info@westdevsolutions.com",
  phoneDisplay: "+1 (876) 818-7799",
  phoneHref: "tel:+18768187799",
  instagramUrl: "https://www.instagram.com/westdevsolutionsllc/",
};
